import { cn } from '@coas/ui/lib';
import { memo } from 'react';
import IconSpinner from '~/shared/assets/icons/spinner.svg';

type SpinnerProps = React.SVGAttributes<SVGSVGElement>;

export const Spinner = memo((props: SpinnerProps) => {
    return (
        <IconSpinner
            {...props}
            className={cn('!bg-transparent animate-spin motion-safe:duration-700', props.className)}
        />
    );
});
